import { c as _c } from "react/compiler-runtime";
import { replaceAccents } from '@/utils/string';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import scrollIntoView from 'scroll-into-view';
import { TOP_OFFSET } from '@/constants/offsets';
import { mergeClasses } from '@/utils/style';
export function useQuickMenu() {
  const $ = _c(4);
  const [activeSection, setActiveSection] = useState("");
  const getSectionId = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (sectionId, subtitle) => `${sectionId}_${getSectionId(subtitle)}`;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const getSubsectionSectionId = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      const link = e.target;
      if (!(link instanceof HTMLButtonElement) || !link.dataset.section) {
        return;
      }
      const section = document.getElementById(link.dataset.section);
      if (!section) {
        return;
      }
      setActiveSection(link.dataset.section);
      scrollIntoView(section, {
        time: 1000,
        align: {
          topOffset: TOP_OFFSET,
          top: 0.1
        }
      });
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleScrollToSection = t1;
  let t2;
  if ($[2] !== activeSection) {
    t2 = {
      activeSection,
      setActiveSection,
      getSectionId,
      getSubsectionSectionId,
      handleScrollToSection
    };
    $[2] = activeSection;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(title) {
  return replaceAccents(title.toLowerCase()).split(" ").join("-");
}
interface Props {
  sections: Array<{
    title: string | React.JSX.Element;
    subsections?: Array<{
      title: string | React.JSX.Element;
    }>;
  }>;
  getSectionId: (title: string) => string;
  getSubsectionSectionId?: (sectionId: string, title: string) => string;
  activeSection: string;
  handleScrollToSection: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}
export function QuickMenu(props) {
  const $ = _c(21);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    sections,
    activeSection,
    getSectionId,
    getSubsectionSectionId,
    handleScrollToSection
  } = props;
  let t1;
  if ($[1] !== t) {
    t1 = t("core:signpost");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <strong className="text-lg font-semibold lg:text-xl">{t1}</strong>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeSection || $[6] !== getSectionId || $[7] !== getSubsectionSectionId || $[8] !== handleScrollToSection || $[9] !== sections) {
    let t4;
    if ($[11] !== activeSection || $[12] !== getSectionId || $[13] !== getSubsectionSectionId || $[14] !== handleScrollToSection) {
      t4 = (t5, i) => {
        const {
          title,
          subsections
        } = t5;
        const sectionId = getSectionId(title.toString());
        return <li className="list-disc" key={i}><button type="button" className={mergeClasses("text-light-gray-500 relative w-full text-left text-sm whitespace-normal", {
            "font-semibold text-gray-900 marker:text-blue-500": activeSection === sectionId || activeSection.includes(`${sectionId}_`)
          })} onClick={handleScrollToSection} data-section={sectionId} aria-current={activeSection === sectionId || activeSection.includes(`${sectionId}_`) ? "true" : undefined}>{title}</button>{subsections && getSubsectionSectionId && <ul>{subsections.map((t6, subI) => {
              const {
                title: title_0
              } = t6;
              const subsectionId = getSubsectionSectionId(sectionId, title_0.toString());
              return <li key={subI}><button type="button" className={mergeClasses("text-light-gray-500 w-full pt-1 pl-6 text-left font-normal", {
                  "font-semibold text-gray-900": activeSection === subsectionId
                })} onClick={handleScrollToSection} data-section={subsectionId} aria-current={activeSection === subsectionId ? "true" : undefined}>{title_0}</button></li>;
            })}</ul>}</li>;
      };
      $[11] = activeSection;
      $[12] = getSectionId;
      $[13] = getSubsectionSectionId;
      $[14] = handleScrollToSection;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    t3 = sections.map(t4);
    $[5] = activeSection;
    $[6] = getSectionId;
    $[7] = getSubsectionSectionId;
    $[8] = handleScrollToSection;
    $[9] = sections;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[16] !== t3) {
    t4 = <ul className="marker:text-light-gray-500 mt-4 flex list-disc flex-col gap-3 pl-5 marker:text-base">{t3}</ul>;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t2 || $[19] !== t4) {
    t5 = <div className="shadow-floating relative w-full rounded-2xl bg-white px-5 py-6 lg:sticky lg:top-[7.25rem] lg:max-w-xs lg:shrink-0 lg:grow-0 lg:basis-80 xl:top-[9.5rem]">{t2}{t4}</div>;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}